import { persistReducer } from "redux-persist"
import allMember from "src/pages/Member/All/ducks"
import bundle_list from "src/pages/Bundle/List/ducks"
import create_order from "src/pages/CreateOrder/ducks"
import medicine from "src/pages/Medicine/ducks"
import newMember from "src/pages/Member/New/ducks"
import notification from "src/features/Notification/notificationSlice"
import payment from "src/pages/Payment/redux"
import storage from "localforage"
import supply from "src/pages/Supply/ducks"
import bundle_create from "src/pages/Bundle/Create/ducks"

import oauth from "src/features/Oauth/oauth.ducks"
import sessionExpiredDialog from "src/features/Authentication/SessionExpiredDialog.ducks"

const oauthConfig = {
  key: "auth",
  storage: storage,
  blacklist: ["initial"],
}

const rootReducer = {
  notification,
  medicine,
  supply,
  allMember,
  bundle_list,
  newMember,
  create_order,
  oauth: persistReducer(oauthConfig, oauth),
  payment,
  sessionExpiredDialog,
  bundle_create,
}

export default rootReducer
